import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getDate } from "../../common/DisplayDate";
import getMotorSubRecordDetails from "./MotorSubRecordDetails";

class VehicleOtherDetails extends Component {
  state = {
    rows: [],
    activeIndex: -1,
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  loadData = (props) => {
    let rows = [];
    if (props.record !== undefined) {
      _.forEach(
        _.get(props.record, "registrants[0].registrant"),
        (record, index) => {
          const historyDescription = _.get(
            record,
            "historyDescription[0]._",
            ""
          );
          _.forEach(
            _.get(record, "registrationInfo"),
            (registrationInfo, regInfIndex) => {
              rows.push(
                <Table.Row
                  key={`veh_reg_inf_title_row_${this.props.detailIndex}_${index}_${regInfIndex}`}
                >
                  <Table.Cell
                    colSpan={4}
                    className={"report-sub-section-header text-center"}
                  >
                    Registration ({historyDescription})
                  </Table.Cell>
                </Table.Row>
              );

              rows.push(
                <Table.Row
                  key={`veh_reg_inf_row_1_${this.props.detailIndex}_${index}_${regInfIndex}`}
                >
                  <Table.Cell>Plate:</Table.Cell>
                  <Table.Cell>
                    {_.get(registrationInfo, "trueLicensePlate[0]._", "")}
                  </Table.Cell>
                  <Table.Cell>Expires:</Table.Cell>
                  <Table.Cell>
                    {getDate(
                      _.get(registrationInfo, "latestExpirationDate[0]")
                    )}
                  </Table.Cell>
                </Table.Row>
              );
              rows.push(
                <Table.Row
                  key={`veh_reg_inf_row_2_${this.props.detailIndex}_${index}_${regInfIndex}`}
                >
                  <Table.Cell>Effective From:</Table.Cell>
                  <Table.Cell>
                    {getDate(
                      _.get(registrationInfo, "earliestEffectiveDate[0]")
                    )}
                  </Table.Cell>
                  <Table.Cell>Effective To:</Table.Cell>
                  <Table.Cell>
                    {getDate(_.get(registrationInfo, "latestEffectiveDate[0]"))}
                  </Table.Cell>
                </Table.Row>
              );
              rows.push(
                <Table.Row
                  key={`veh_reg_inf_row_3_${this.props.detailIndex}_${index}_${regInfIndex}`}
                >
                  <Table.Cell>Previous Plate:</Table.Cell>
                  <Table.Cell>
                    {_.get(registrationInfo, "previousLicensePlate[0]._", "")}
                  </Table.Cell>
                  <Table.Cell>Previous State:</Table.Cell>
                  <Table.Cell>
                    {_.get(registrationInfo, "previousLicenseState[0]._", "")}
                  </Table.Cell>
                </Table.Row>
              );
            }
          );
          _.forEach(
            _.get(props.record, "registrants[0].registrant"),
            (registrant, regntIndex) => {
              const registrantInfo = _.get(registrant, "registrantInfo[0]");
              const titleInfo = _.get(registrant, "titleInfo[0]");
              const recordType = _.get(registrant, "$.display");
              if (registrantInfo !== undefined) {
                rows = rows.concat(
                  getMotorSubRecordDetails(
                    registrantInfo,
                    recordType,
                    titleInfo,
                    props,
                    `_${index}_${regntIndex}`
                  )
                );
              }
            }
          );
        }
      );
      _.forEach(_.get(props.record, "owners[0].owner"), (owner, ownerIndex) => {
        const recordInfo = _.get(owner, "ownerInfo[0]");
        const titleInfo = _.get(owner, "titleInfo[0]");
        const recordType = _.get(owner, "$.display");
        if (recordInfo !== undefined) {
          rows = rows.concat(
            getMotorSubRecordDetails(
              recordInfo,
              recordType,
              titleInfo,
              props,
              `_${props.detailIndex}_${ownerIndex}`
            )
          );
        }
      });
      _.forEach(
        _.get(props.record, "lienHolders[0].lienHolder"),
        (lienHolder, lienHolderIndex) => {
          const recordInfo = _.get(lienHolder, "lienHolderInfo[0]");
          const titleInfo = _.get(lienHolder, "titleInfo[0]");
          const recordType = _.get(lienHolder, "$.display");
          if (recordInfo !== undefined) {
            rows = rows.concat(
              getMotorSubRecordDetails(
                recordInfo,
                recordType,
                titleInfo,
                props,
                `_${props.detailIndex}_${lienHolderIndex}`
              )
            );
          }
        }
      );
      _.forEach(
        _.get(props.record, "lessees[0].lessee"),
        (lessee, lesseeIndex) => {
          const recordInfo = _.get(lessee, "lesseeInfo[0]");
          const titleInfo = _.get(lessee, "titleInfo[0]");
          const recordType = _.get(lessee, "$.display");
          if (recordInfo !== undefined) {
            rows = rows.concat(
              getMotorSubRecordDetails(
                recordInfo,
                recordType,
                titleInfo,
                props,
                `_${props.detailIndex}_${lesseeIndex}`
              )
            );
          }
        }
      );
      _.forEach(
        _.get(props.record, "lessors[0].lessor"),
        (lessor, lessorIndex) => {
          const recordInfo = _.get(lessor, "lessorInfo[0]");
          const titleInfo = _.get(lessor, "titleInfo[0]");
          const recordType = _.get(lessor, "$.display");
          if (recordInfo !== undefined) {
            rows = rows.concat(
              getMotorSubRecordDetails(
                recordInfo,
                recordType,
                titleInfo,
                props,
                `_${props.detailIndex}_${lessorIndex}`
              )
            );
          }
        }
      );
    }
    this.setState({ rows });
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Table>
        <Table.Body>{this.state.rows}</Table.Body>
      </Table>
    );
  }
}

export default VehicleOtherDetails;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/VehicleOtherDetails.js